import moment from 'moment-timezone'
import { UTCFormatDate, getProgramDatesRange } from './date'

// Mirrors server fallbacks for experiences without saved payment defaults
export const QUEST_PAYMENT_DEFAULTS = {
  DEPOSIT_PERCENTAGE: 25,
  AUTO_DEDUCT_DAYS: 120,
}

// value 100 = full amount at booking
export const DEPOSIT_PERCENTAGE_OPTIONS = [
  { value: 100, label: 'Full amount at booking' },
  { value: 25, label: '25% to hold the place' },
  { value: 50, label: '50% to hold the place' },
  { value: 75, label: '75% to hold the place' },
]

// value 0 = remaining balance is collected with the deposit (no later auto-charge)
export const AUTO_DEDUCT_DAYS_OPTIONS = [0, 30, 60, 90, 120]

/** Parses "$12,500" / 12500 into a number; empty or invalid -> 0. */
export const stripCurrencyValue = (val) => {
  if (val === undefined || val === null || val === '') return 0
  const n = Number(String(val).replace(/[^0-9.]/g, ''))
  return Number.isFinite(n) ? n : 0
}

/** True when a money value was entered (including 0 / $0). */
export const isDiscountProvided = (val) => {
  if (val === undefined || val === null || val === '') return false
  return String(val).replace(/[^0-9.]/g, '') !== ''
}

/**
 * @param {Object} investments - quest.investments
 * @returns {number} experience deposit percentage (1-100)
 */
export const getDepositPercentage = (investments) =>
  investments?.defaultDepositPercentage ||
  QUEST_PAYMENT_DEFAULTS.DEPOSIT_PERCENTAGE

/**
 * @param {Object} investments - quest.investments
 * @returns {number} days before start the remaining balance is auto-charged (0 = with deposit)
 */
export const getAutoDeductDays = (investments) =>
  investments?.defaultAutoDeductDays ?? QUEST_PAYMENT_DEFAULTS.AUTO_DEDUCT_DAYS

/**
 * Deposit = percentage of the discounted cost when set (incl. 0), else of the actual cost.
 * @returns {string} rounded amount, or '' when there is no cost yet
 */
export const calculateDepositAmount = (
  actualCost,
  discountedCost,
  percentage = QUEST_PAYMENT_DEFAULTS.DEPOSIT_PERCENTAGE,
) => {
  const base = isDiscountProvided(discountedCost)
    ? stripCurrencyValue(discountedCost)
    : stripCurrencyValue(actualCost)
  if (!base && !isDiscountProvided(discountedCost)) return ''
  return String(Math.round((base * percentage) / 100))
}

/**
 * Start date minus `days`, in UTC.
 * @param {string|Date} startDate - experience start date
 * @param {number} days - days before start
 * @returns {moment.Moment|null} null without a start date or when days is 0
 */
export const getAutoDeductDateFromStart = (startDate, days) => {
  if (!startDate || !days) return null
  return moment.utc(startDate).startOf('day').subtract(days, 'days')
}

/**
 * Experience default auto-deduct date formatted for the date picker (MM/DD/YYYY).
 * @param {Object} quest - quest detail with programDatesList
 * @param {Object} investments - quest.investments (falls back to quest.investments)
 * @returns {string} '' when there is no default date
 */
export const getDefaultAutoDeductDateValue = (quest, investments) => {
  const date = getAutoDeductDateFromStart(
    getProgramDatesRange(quest).start,
    getAutoDeductDays(investments ?? quest?.investments),
  )
  return date ? UTCFormatDate(date) : ''
}
